import { useEffect } from "react";
import {
    Container,
    Card,
    Header,
    LogoWrapper,
    Title,
    DateText,
    Button,
    OTFormWrapper,
} from "../../styles/pages/PoliticaPrivacidade/PoliticaPrivacidadeMobileStyles";
import { ReactComponent as LogoPuc } from "../../assets/images/logo_pucpr_horizontal_rgb 1.svg";

const PoliticaPrivacidadeNova = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://privacyportal-br-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js";
        script.type = "text/javascript";
        script.charset = "UTF-8";
        script.id = "otprivacy-notice-script";

        const settings = {
            callbackUrl:
                "https://mps-marista-privacy.my.onetrust.com/request/v1/privacyNotices/stats/views",
        };

        const base64Settings = btoa(JSON.stringify(settings));
        script.setAttribute("settings", base64Settings);

        script.onload = () => {
            if (window.OneTrust?.NoticeApi?.Initialized) {
                window.OneTrust.NoticeApi.Initialized.then(() => {
                    window.OneTrust.NoticeApi.LoadNotices([
                        "https://privacyportal-br-cdn.onetrust.com/c3f9b2c6-6e02-4c7e-a5ce-b8fdf03280c1/privacy-notices/b5a45cd1-9cef-42f3-bb6e-3ef0dafe78f4.json",
                    ]);
                });
            }
        };

        document.body.appendChild(script);
    }, []);

    return (
        <Container>
            <Card>
                <Header>
                    <LogoWrapper>
                        <LogoPuc />
                    </LogoWrapper>
                    <Title>Aviso de Privacidade</Title>
                </Header>

                <div
                    id="otnotice-b5a45cd1-9cef-42f3-bb6e-3ef0dafe78f4"
                    className="otnotice"
                />

                <OTFormWrapper id="form">
                    <iframe
                        src="https://mps-marista-privacy.my.onetrust.com/webform/c3f9b2c6-6e02-4c7e-a5ce-b8fdf03280c1/b83e7d47-0eee-4124-b4e7-a17dd58a6640"
                        title="Formulário de Solicitação de Privacidade"
                    />
                </OTFormWrapper>

                <a href="/">
                    <Button>Voltar para o início</Button>
                </a>
            </Card>
        </Container>
    );
};

export default PoliticaPrivacidadeNova;
